import { createSlice } from '@reduxjs/toolkit';

//**********************************************************

// define a type for the slice state
interface device
{
    id: number;
    mobile: string;
    carName: string;
    deviceId: string;
    imei: string;
    deviceType: string;
    selected: number;

    concoxActiveSystem: any;
    concoxInactiveSystem: any;
    concoxCurrentLocation: any;
    concoxTurnOff: any;
    concoxAlarmSpeed: any;
    concoxAlarmDisconnectBattery: any;
    concoxAlarmDoor: any;
    concoxAlarmImpact: any;
    concoxAlarmMoving: any;
    concoxAlarmTurnOn: any;
    concoxAlarmTurnOff: any;
    concoxResetDevice: any;
    concoxCentralNumber: any;
    concoxDeviceAdmin: any;
    cobanActiveSystem: any;
    cobanInactiveSystem: any;
    cobanActiveListen: any;
    cobanInactiveListen: any;
    cobanTurnOff: any;
    cobanAlarmSpeed: any;
    cobanAlarmMoving: any;
    cobanAlarmTurnOn: any;
    cobanAlarmSOS: any;
    cobanResetDevice: any;
    cobanPointDistance: any;
    cobanDeviceAdmin: any;

    deviceAdminMobile1: any;
    deviceAdminMobile2: any;
    deviceAdminMobile3: any;

    centralNumberMobile1: any;
    centralNumberMobile2: any;
    centralNumberMobile3: any;

    distanceMinute: any;
    distanceSecond: any;
}

//**********************************************************

export const deviceState = createSlice
(
    {
        name: 'deviceState',
        initialState:
            {
                id: 0,
                mobile: '',
                carName: '',
                deviceId: '',
                imei: '',
                deviceType: '',
                selected: 0,
                concoxActiveSystem: "",
                concoxInactiveSystem: "",
                concoxCurrentLocation: "",
                concoxTurnOff: "",
                concoxAlarmSpeed: "",
                concoxAlarmDisconnectBattery: "",
                concoxAlarmDoor: "",
                concoxAlarmImpact: "",
                concoxAlarmMoving: "",
                concoxAlarmTurnOn: "",
                concoxAlarmTurnOff: "",
                concoxResetDevice: "",
                concoxCentralNumber: "",
                concoxDeviceAdmin: "",
                cobanActiveSystem: "",
                cobanInactiveSystem: "",
                cobanActiveListen: "",
                cobanInactiveListen: "",
                cobanTurnOff: "",
                cobanAlarmSpeed: "",
                cobanAlarmMoving: "",
                cobanAlarmTurnOn: "",
                cobanAlarmSOS: "",
                cobanResetDevice: "",
                cobanPointDistance: "",
                cobanDeviceAdmin: "",
                deviceAdminMobile1: '',
                deviceAdminMobile2: '',
                deviceAdminMobile3: '',
                centralNumberMobile1: '',
                centralNumberMobile2: '',
                centralNumberMobile3: '',
                distanceMinute: '',
                distanceSecond: '',
            },
        reducers:
            {
                save: (state, action) =>
                {
                    state.id = action.payload.id;
                    state.mobile = action.payload.mobile;
                    state.carName = action.payload.carName;
                    state.deviceId = action.payload.deviceId;
                    state.imei = action.payload.imei;
                    state.deviceType = action.payload.deviceType;
                    state.selected = action.payload.selected;

                    state.concoxActiveSystem = action.payload.concoxActiveSystem;
                    state.concoxInactiveSystem = action.payload.concoxInactiveSystem;
                    state.concoxCurrentLocation = action.payload.concoxCurrentLocation;
                    state.concoxTurnOff = action.payload.concoxTurnOff;
                    state.concoxAlarmSpeed = action.payload.concoxAlarmSpeed;
                    state.concoxAlarmDisconnectBattery = action.payload.concoxAlarmDisconnectBattery;
                    state.concoxAlarmDoor = action.payload.concoxAlarmDoor;
                    state.concoxAlarmImpact = action.payload.concoxAlarmImpact;
                    state.concoxAlarmMoving = action.payload.concoxAlarmMoving;
                    state.concoxAlarmTurnOn = action.payload.concoxAlarmTurnOn;
                    state.concoxAlarmTurnOff = action.payload.concoxAlarmTurnOff;
                    state.concoxResetDevice = action.payload.concoxResetDevice;
                    state.concoxCentralNumber = action.payload.concoxCentralNumber;
                    state.concoxDeviceAdmin = action.payload.concoxDeviceAdmin;
                    state.cobanActiveSystem = action.payload.cobanActiveSystem;
                    state.cobanInactiveSystem = action.payload.cobanInactiveSystem;
                    state.cobanActiveListen = action.payload.cobanActiveListen;
                    state.cobanInactiveListen = action.payload.cobanInactiveListen;
                    state.cobanTurnOff = action.payload.cobanTurnOff;
                    state.cobanAlarmSpeed = action.payload.cobanAlarmSpeed;
                    state.cobanAlarmMoving = action.payload.cobanAlarmMoving;
                    state.cobanAlarmTurnOn = action.payload.cobanAlarmTurnOn;
                    state.cobanAlarmSOS = action.payload.cobanAlarmSOS;
                    state.cobanResetDevice = action.payload.cobanResetDevice;
                    state.cobanPointDistance = action.payload.cobanPointDistance;
                    state.cobanDeviceAdmin = action.payload.cobanDeviceAdmin;
                    state.deviceAdminMobile1 = action.payload.deviceAdminMobile1;
                    state.deviceAdminMobile2 = action.payload.deviceAdminMobile2;
                    state.deviceAdminMobile3 = action.payload.deviceAdminMobile3;
                    state.centralNumberMobile1 = action.payload.centralNumberMobile1;
                    state.centralNumberMobile2 = action.payload.centralNumberMobile2;
                    state.centralNumberMobile3 = action.payload.centralNumberMobile3;
                    state.distanceMinute = action.payload.distanceMinute;
                    state.distanceSecond = action.payload.distanceSecond;
                },
            },
    }
);

// Action creators are generated for each case reducer function
export const { save } = deviceState.actions;

export default deviceState.reducer;
